/*
 * © Copyright 2014 – 2023 Open Text or one of its affiliates.
 *
 * The only warranties for products and services of Open Text and its affiliates and licensors ("Open Text") are as
 * may be set forth in the express warranty statements accompanying such products and services. Nothing herein should be
 * constituting an additional warranty. Open Text shall not be liable for technical or editorial errors or omissions
 * contained herein.
 *
 * The information contained herein is subject to change without notice.
 */

import StatusIndicator from '../../ux/StatusIndicator';
import React from 'react';
import PropTypes from 'prop-types';

function AuthenticatorStatus({statusMessage}) {
    if (!statusMessage) {
        return null;
    }

    return (
        <StatusIndicator type={statusMessage.type}>
            {statusMessage.description}
        </StatusIndicator>
    );
}

AuthenticatorStatus.propTypes = {
    statusMessage: PropTypes.shape({
        description: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired
    })
};

export default AuthenticatorStatus;
